const APPROVED_POSTERS = new Set([
  'boggsnathan@gmail.com',
  'ebonyhouse10@gmail.com',
  'lscottcook1@gmail.com',
  'theurbanlandlordclips@gmail.com',
]);

export const canPost = (user) => !!user && APPROVED_POSTERS.has(user.email);
